import { defineStore } from 'pinia';
import { useStoreConfiguration } from '../configuration/configuration';
import { ref, watch } from 'vue';
import type { StoreNavigationFooter } from '../../types/footer';

const storeId = 'store-footer-nav';

export const useStoreNavigationFooter = defineStore(storeId, () => {
  const storeConfiguration = useStoreConfiguration();
  const config = ref<StoreNavigationFooter['config']>();

  function init() {
    if (!storeConfiguration.config) {
      return;
    }

    const {
      pt_footer_cols,
      pt_footer_copyright_text,
      pt_footer_shop_badges,
      pt_default_contact,
      pt_contact_page,
    } = storeConfiguration.config;

    config.value = {
      pt_footer_cols,
      pt_footer_copyright_text,
      pt_footer_shop_badges,
      pt_default_contact,
      pt_contact_page,
    };
  }

  watch(storeConfiguration, () => {
    if (storeConfiguration.config) {
      init();
    }
  });

  return { config };
});
